import { FC } from "preact/compat";
import { DayBoxProps } from "./interfaces";
import cn from "classnames";

const DayBox: FC<DayBoxProps> = ({ color, content }) => (
    <span className={cn("d-day-box", color)}>{content ?? "-"}</span>
);

export default DayBox;
